import React, { Component } from 'react';
import { BUILDER_TYPES } from '../../config/constants';


export default class CreateButtons extends Component {

    render() {
        const isUpdateMode = 'UPDATE_FORM_CONFIG' in window;

        return (
            this.props.activeBuilderType === BUILDER_TYPES.FORM ?
                <button
                    disabled={this.props.loading}
                    className="btn btn-submit-form btn-primary"
                    onClick={this.props.createForm}
                >{  this.props.loading ? 'Loading' : isUpdateMode ? 'Update Form' : 'Create Form' }</button>
                :

                <button
                    disabled={this.props.loading}
                    className="btn btn-submit-form btn-primary"
                    onClick={this.props.createSuccessPage}
                >{  this.props.loading ? 'Loading' : isUpdateMode ? 'Update Success Page' : 'Create Success Page' }</button>
        );
    }
}




